export enum POLICY_AGREEMENT {
  DATA_PRIVACY_AGREEMENT = 'DATA_PRIVACY_AGREEMENT',
  FEE_AGREEMENT_FOR_DOCTOR_CONSULTATION = 'FEE_AGREEMENT_FOR_DOCTOR_CONSULTATION',
  FEE_AGREEMENT_FOR_PHYSIOTHERAPY = 'FEE_AGREEMENT_FOR_PHYSIOTHERAPY',
  TREATMENT_AGREEMENT = 'TREATMENT_AGREEMENT',
}
